<div class="mainContainer">
<div class="container">

  <p>Camera Sélectionnée : {{camera}}</p>
  <p>Panne Sélectionnée : {{panne}}</p>
  <div class="compteur">
<p *ngIf="pbMateriel != 0" >Problème matériel : {{pbMateriel}}</p>
  <p *ngIf="pbManipulation != 0" >Problème de manipulation : {{pbManipulation}}</p>
  <p *ngIf="pbSysteme != 0" >Problème système : {{pbSysteme}}</p>
  <p *ngIf="pbReseau != 0" >Problème réseau : {{pbReseau}}</p>
  <p *ngIf="autre != 0" >Autre : {{autre}}</p>
  <p *ngIf="aucunePanne != 0" >Panne non classifiée : {{aucunePanne}}</p>
  <p *ngIf="pbEPMairie != 0" >Problème EP DEP : {{pbEPMairie}}</p>
  <p *ngIf="allOld != 0" >Total des pannes : {{allOld}}</p>


  <p *ngIf="horsLigne != 0" >Hors Ligne : {{horsLigne}}</p>
  <p *ngIf="imageDegrade != 0" >Image dégradée : {{imageDegrade}}</p>
  <p *ngIf="defautEnregistrement != 0" >Défaut enregistrement : {{defautEnregistrement}}</p>
  <p *ngIf="nonManipulable != 0" >Non manipulable : {{nonManipulable}}</p>
  <p *ngIf="affichageTuile != 0" >Défaut affichage Tuile : {{affichageTuile}}</p>
  <p *ngIf="affichageMur != 0" >Affichage mur d’image : {{affichageMur}}</p>
  <p *ngIf="vandalisme != 0" >Caméras vandalisées : {{vandalisme}}</p>
  <p *ngIf="vibration != 0" >Capteur Vibration : {{vibration}}</p>
  <p *ngIf="sonore != 0" >Défaut Haut-parleur : {{sonore}}</p>
  <p *ngIf="poste != 0" >Défaut poste opérateur : {{poste}}</p>
  <p *ngIf="intrusion != 0" >alarme local technique : {{intrusion}}</p>
  <p *ngIf="cartographie != 0" >Cartographie : {{cartographie}}</p>
  <p *ngIf="allNew != 0" >Total des pannes : {{allNew}}</p>


    </div>

  <button class="buttonLink" *ngIf="activateButton == true && activateSla == true"   (click)="displayChart()">Mode Distribution</button>
  <button class="buttonLink" *ngIf="activateButton == false  && activateSla == true" (click)="removeChart()">Mode Rapport</button>
  <button class="buttonLink" *ngIf="activateSla == true" (click)="addSla()" >Activer Sla</button>
  <button class="buttonLink" *ngIf="activateSla == false" (click)="removeSla()">Mode Rapport</button>
</div>

<div id="container2"></div>
<div id="container3"></div>

</div>
<img class="image "src="../../assets/Logo_Toulouse.png" alt="Logo Toulouse">
